import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { clearChats, markChatAsRead } from '../actions';

import MessagesTemplateListContainer from '../../MessagesTemplate/MessagesTemplateListContainer';
import MessageListItemContainer from './MessageListItemContainer';

const MessagesListContainer = (props) => {
  const { baseUrl } = props;
  return (
    <MessagesTemplateListContainer
      {...props}
      messageUrl={`${baseUrl}/messages`}
      MessageTemplateListItem={MessageListItemContainer}
    />
  );
};

MessagesListContainer.propTypes = {
  baseUrl: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const {
    messages: { results: chats, next: nextMessages, selectValue },
    buildings,
  } = state;
  return {
    chats,
    nextMessages,
    selectValue,
    buildings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onMarkChatAsRead: (chatId) => markChatAsRead(dispatch, chatId),
  clearChats: () => clearChats(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MessagesListContainer);
